// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".room-table-component .delete-btn[data-v-35e6bc1f],.room-table-component .edit-btn[data-v-35e6bc1f]{width:64px}.room-table-component .edit-btn[data-v-35e6bc1f]{margin-right:12px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
